import axios from 'axios';

export const getWorkRequestsPriorityAndStatusChart=(query:string)=>{
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL+`order-request/graph?where=`+query
  );
}
export const updateOrderRequest=(obj:any)=>{
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`order-request/update`,obj
    
  );
}